import App from './App';
new App().start();